// extracted by mini-css-extract-plugin
module.exports = {"container":"JobItem_container__t3YWJ","infoRow":"JobItem_infoRow__94Tsl","btn":"JobItem_btn__0vM34"};